import React, { Component } from 'react';
import { connect } from 'react-redux';
import Map from './Map.js';
import List from './List.js';
import {
  SET_SEARCH_RESULTS
} from './actions/index'

/**
TODO: Load list of wannas that is matching the search text
TODO: Display list of wannas in a list
TODO: Display list of wannas in a map
TODO: Add list/map toggle
 */

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: null,
    };
  }

  render() {
    const content = (
      <List/>
    );

    return <main className="App-main">{content}</main>;
  }

  // let content;
  //   if (this.props.google) {
  //     content = (
  //       <Map
  //         google={this.props.google}
  //         users={this.state.users}
  //         onUserLocationUpdate={location => this.onUserLocationUpdate(location)}
  //       />
  //     );
  //   } else {
  //     content = <p>Loading...</p>;
  //   }

  componentDidMount() {
    // this.props.firebase
    //   .firestore()
    //   .collection('users')
    //   .where('wanna', '>=', this.props.wanna)
    //   .onSnapshot(querySnapshot => {
    //     querySnapshot.forEach(function(doc) {
    //       // doc.data() is never undefined for query doc snapshots
    //       console.log(doc.id, ' => ', doc.data());
    //     });

    //     this.setState({
    //       users: querySnapshot
    //     });
    //   });
  }

  componentDidUpdate() {
    if (this.state.searchText !== this.props.searchText) {
      this.updateSearchResults();
    }
  }

  onUserLocationUpdate(location) {
    // // Get a key for a new Post.
    // var newPostKey = firebase.database().collection('users').doc('').key;

    // // Write the new post's data simultaneously in the posts list and the user's post list.
    // var updates = {};
    // updates['/posts/' + newPostKey] = postData;
    // updates['/user-posts/' + uid + '/' + newPostKey] = postData;

    // return firebase.database().ref().update(updates);

    // console.log('User location update: ' + JSON.stringify(location));

    // let user = this.props.firebase.auth().currentUser;

    // if (!user) {
    //   return;
    // }

    // this.props.firebase
    //   .firestore()
    //   .collection('users')
    //   .doc(user.uid)
    //   .update({
    //     location: new this.props.firebase.firestore.GeoPoint(
    //       location.lat,
    //       location.lng
    //     )
    //   });

    // console.log('Firebase updated: ' + JSON.stringify(location));
  }

  updateSearchResults() {
    const self = this;

    // TODO: Unregister subscription
    this.props.firebase
      .firestore()
      .collection('wannas')
      .where('title', '>=', this.generateSearchLowerBound(this.props.searchText))
      .where('title', '<', this.generateSearchUpperBound(this.props.searchText))
      .onSnapshot(querySnapshot => {
        self.setState(Object.assign({}, self.state, {
          searchText: this.props.searchText
        }));

        const results = querySnapshot.docs.map(snapshot => Object.assign({}, snapshot.data(), {
          id: snapshot.id
        }));

        self.props.dispatch({
          type: SET_SEARCH_RESULTS,
          searchResults: results
        });
      });
  }

  generateSearchLowerBound(text) {
    return text;
  }

  generateSearchUpperBound(text) {
    return text.slice(0, text.length - 1) + String.fromCharCode(text.charCodeAt(text.length - 1) + 1);
  }
}

const mapStateToProps = (state, props) => {
  return Object.assign({}, props, {
    searchText: state.searchText,
    firebase: state.firebase
  });
};

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/Main.js